import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function Button({
  children,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const sharedClasses = `inline-block text-center bg-brand-gold hover:bg-brand-goldHover text-brand-charcoal font-bold py-4 px-8 rounded-sm shadow-lg transition-colors duration-300 text-sm md:text-base tracking-wide uppercase cursor-pointer ${className}`;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={sharedClasses} data-id="element-32">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={sharedClasses} {...props} data-id="element-33">
      {children}
    </motion.button>;
}